import React from 'react'
import { useTheme } from '@mui/material'

// Botão em forma de pílula para escolhas curtas (modo de importar, recorrência,
// dias da semana). Usado pelo agendamento e pelo disparo em massa.
export default function Pilula({ ativo, children, onClick }) {
  const theme = useTheme()
  return (
    <button
      type="button"
      onClick={onClick}
      className="text-sm font-medium px-3 py-1.5 rounded-full mr-2 mb-2"
      style={{
        cursor: 'pointer',
        border: `1px solid ${ativo ? theme.palette.primary.main : theme.palette.divider}`,
        color: ativo ? theme.palette.primary.main : 'inherit',
        backgroundColor: ativo ? `${theme.palette.primary.main}1f` : 'transparent'
      }}
    >
      {children}
    </button>
  )
}
